import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/plan_table'
import PlanService from '../../network/services/plan'
import { serialize } from '../../network/request'
import PlanTable from './PlanTable'

const PlanPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Plan
    </Button>
  )

  return (
    <PageHeader title="All Plans" extra={[primaryAction]}>
      <Card>
        <PlanTableWrapper />
      </Card>
    </PageHeader>
  )
}

const PlanTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(PlanService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = PlanService.toPaginate(response)

  return (
    <>
      <PlanTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <PlanTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default PlanPage
